import {
  GET_CALLBACKS,
  GET_CALLBACKS_SUCCESS,
  GET_CALLBACKS_ERROR,
} from "./actionTypes";

const initialState = {
  errorGetCallbacks: "",
  loadingGetCallbacks: false,
  pendingCallbacks: null,
  successGetCallback: "",
};

const getCallbacks = (state = initialState, action) => {
  switch (action.type) {
    case GET_CALLBACKS:
      state = {
        ...state,
        loadingGetCallbacks: true,
      };
      break;
    case GET_CALLBACKS_SUCCESS:
      state = {
        ...state,
        loadingGetCallbacks: false,
        pendingCallbacks: action.payload.pendingCallbacks,
        successGetCallback: action.payload.message,
      };
      break;
    case GET_CALLBACKS_ERROR:
      state = {
        ...state,
        errorGetCallbacks: action.payload,
        loadingGetCallbacks: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getCallbacks;
